export const exportsDropdown = [
    { label: 'Посетители', value: 'visitors' },
    { label: 'Заказы', value: 'orders' },
];
